import { render, staticRenderFns } from "./admin-warning.vue?vue&type=template&id=43f880e0&scoped=true&lang=pug&"
import script from "./admin-warning.vue?vue&type=script&lang=js&"
export * from "./admin-warning.vue?vue&type=script&lang=js&"
import style0 from "./admin-warning.vue?vue&type=style&index=0&id=43f880e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f880e0",
  null
  
)

/* custom blocks */
import block0 from "./admin-warning.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports